import { getMainDocumentTypeByCountry, getAliasesDocumentType } from 'utilities/multiLanguageHelper';
import { getBirthCountries } from './getBirthCountries';
import { getNationalityCountries } from './getNationalityCountries';

export const getCountries = ({ documentType, options }) => {
    const listCountries = options.get('countries').toJSON();
    const mainDocumentType = getMainDocumentTypeByCountry();
    const isRegisteringWithMainDocumentType =
        documentType === mainDocumentType || documentType === getAliasesDocumentType(mainDocumentType);

    const birthCountries = getBirthCountries({ listCountries, isRegisteringWithMainDocumentType });
    const nationalityCountries = getNationalityCountries({ listCountries, isRegisteringWithMainDocumentType });

    return {
        birthCountries,
        nationalityCountries,
    };
};
